import React from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import TitleBreadcrumbs from '@atlassian/jira-software-deployments-title-breadcrumbs/src/ui/index.tsx';
import illustrationImg from './assets/deployments-not-available.svg';
import messages from './messages';

export const NotAvailablePage = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={pageWrapperStyles}>
			<HeaderWrapper>
				<TitleBreadcrumbs />
			</HeaderWrapper>
			<BodyWrapper>
				<IllustrationWrapper src={illustrationImg} aria-hidden />
				<Heading size="medium">{formatMessage(messages.title)}</Heading>
				<Description>{formatMessage(messages.description)}</Description>
			</BodyWrapper>
		</Box>
	);
};

const pageWrapperStyles = xcss({
	width: '100%',
	height: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.div({
	padding: `0 ${token('space.500', '40px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BodyWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IllustrationWrapper = styled.img({
	marginTop: token('space.600', '48px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.div({
	marginTop: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 40}px`,
	textAlign: 'center',
});
